import { useEffect, useState } from "react";
import { api, gbp } from "@/lib/api";
import { PageHero } from "@/components/PageHero";
import { BookingDialog } from "@/components/BookingDialog";
import { Button } from "@/components/ui/button";
import { Loader2, Check, Moon, Building2 } from "lucide-react";

export default function Umrah() {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/umrah").then(({ data }) => setPacks(data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHero title="Umrah & Hajj packages" subtitle="Complete spiritual journeys with visa, flights, hotels and Ziyarat." image="https://images.unsplash.com/photo-1513072064285-240f87fa81e8" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        {loading ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#0B3C5D]" /></div> : (
          <div className="grid gap-6 md:grid-cols-3">
            {packs.map((p) => (
              <div key={p.id} data-testid={`umrah-card-${p.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="relative h-48">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                  {p.featured && <span className="absolute top-3 left-3 bg-[#FF6B35] text-white rounded-full px-3 py-1 text-xs font-bold">Popular</span>}
                  <span className="absolute bottom-3 left-3 bg-black/60 text-white rounded-full px-2.5 py-1 text-xs flex items-center gap-1"><Moon className="w-3 h-3" /> {p.nights} nights</span>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-display font-semibold text-lg text-slate-900">{p.title}</h3>
                  <div className="text-xs text-slate-500 mt-2 space-y-1">
                    <p className="flex items-center gap-1.5"><Building2 className="w-3.5 h-3.5 text-[#328CC1]" /> Makkah: {p.hotel_makkah}</p>
                    <p className="flex items-center gap-1.5"><Building2 className="w-3.5 h-3.5 text-[#328CC1]" /> Madinah: {p.hotel_madinah}</p>
                  </div>
                  <ul className="mt-3 space-y-1 flex-1">
                    {(p.includes || []).map((i) => <li key={i} className="text-xs text-slate-600 flex items-center gap-1.5"><Check className="w-3.5 h-3.5 text-[#328CC1]" /> {i}</li>)}
                  </ul>
                  <div className="flex items-end justify-between mt-4 pt-4 border-t border-slate-100">
                    <div><p className="text-[11px] text-slate-400">per person</p><p className="font-display text-2xl font-bold text-[#0B3C5D]">{gbp(p.price)}</p></div>
                    <BookingDialog productType="umrah" item={p} unitPrice={p.price}
                      trigger={<Button data-testid={`book-umrah-${p.id}`} className="rounded-full bg-[#FF6B35] hover:bg-[#e85a26] text-white font-semibold">Book</Button>} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
